module.exports = __webpack_public_path__ + "img/car3.bb80a29c.png";